// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"218":"c93f39dd14b4aea31856","231":"a9ce2f0cad2adc23bcae","680":"a570af5846d974bdb80a","691":"37f8b9d7c27bd4a35120","774":"36b8f0517be7934c749e"}[chunkId] + ".js";
};